import { createFileRoute } from "@tanstack/react-router"
import { AiTripPlannerPage } from "@/components/pages/AiTripPlannerPage"
import { defaultMeta } from "@/lib/seo"

// Dedicated landing page for the "ai trip planner" query family — the head
// terms live here so the homepage can stay on the broader collaborative pitch.
export const Route = createFileRoute(`/_public/ai-trip-planner`)({
  ssr: true,
  head: () =>
    defaultMeta({
      title: `Free AI Trip Planner — Itineraries on a Live Map`,
      description: `Free AI trip planner: Chic, your copilot, drafts a day-by-day starting point in seconds, pins every stop on a live map, and your whole group edits the trip together in real time.`,
      path: `/ai-trip-planner`,
    }),
  component: AiTripPlannerPage,
})
